import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from '@app/components/UI/Header/Header';
import '@app/scss/style.scss';

const LayoutShort: React.FC = () => {
	return (
		<div className="app-container">
			<Header />
			<div className="app-container-content">
				<Outlet />
			</div>
		</div>
	);
};

export default LayoutShort;
